import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterCriteria } from '@woolworthsnz/trader-api';
import { ButtonComponent, SvgIconComponent } from '@woolworthsnz/styleguide';
import { NgFor } from '@angular/common';

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'search-filter-tags',
	templateUrl: './filter-tags.component.html',
	styleUrls: ['./filter-tags.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgFor, ButtonComponent, SvgIconComponent]
})
export class FilterTagsComponent {
	@Input() filters: FilterCriteria[] = [];
	@Output() removeFilter = new EventEmitter<FilterCriteria>();
	@Output() removeAllFilters = new EventEmitter<void>();

	onRemoveFilter = (filter: FilterCriteria): void => this.removeFilter.emit(filter);
	onRemoveAllFilters = (): void => this.removeAllFilters.emit();
}
